import { MessageType } from '../../../type';
import { Box } from '@mui/material';
import { LocalRawFileMessage } from './LocalRawFileMessage';
import { LocalMediaMessage } from './LocalMediaMessage';

type LocalFileMessageProps = {
  channelGuid: string;
  messageGuid: string;
  messageType: Exclude<MessageType, 'TEXT'>;
  url?: string;
  fileName?: string;
};

export const LocalFileMessage = (props: LocalFileMessageProps) => {
  const { channelGuid, messageGuid, messageType, url, fileName } = props;
  switch (messageType) {
    case 'PDF':
      return (
        <LocalRawFileMessage
          icon={
            <Box
              component='img'
              src='/public/assets/icons/ic_pdf.svg'
              sx={{ height: 24, objectFit: 'cover' }}
            />
          }
          channelGuid={channelGuid}
          messageGuid={messageGuid}
          fileName={fileName}
        />
      );
    case 'WORD':
      return (
        <LocalRawFileMessage
          icon={
            <Box
              component='img'
              src='/public/assets/icons/ic_word.svg'
              sx={{ height: 24, objectFit: 'cover' }}
            />
          }
          channelGuid={channelGuid}
          messageGuid={messageGuid}
          fileName={fileName}
        />
      );
    case 'IMAGE':
      return (
        <LocalMediaMessage
          channelGuid={channelGuid}
          messageGuid={messageGuid}
          messageType='IMAGE'
          url={url}
          fileName={fileName}
        />
      );
    case 'VIDEO':
      return (
        <LocalMediaMessage
          channelGuid={channelGuid}
          messageGuid={messageGuid}
          messageType='VIDEO'
          url={url}
          fileName={fileName}
        />
      );
  }
};
